// extracted by mini-css-extract-plugin
export default {"disabledPhoneNumber":"MobileRecordedUserEntry_disabledPhoneNumber__sMlnC"};